// extracted by css-extract-rspack-plugin
export default {"authWarningIcon":"AgentListItems-module__authWarningIcon__V9BQm"};